import { isProduction } from '@/utils/env';
import createCache from '@emotion/cache';

export const createEmotionCache = () => {
  return createCache({
    key: isProduction ? 'css' : 'dev',
    prepend: false,
  });
};
